import React from 'react';
import { Container, Typography, Box, Paper, List, ListItem, ListItemIcon, ListItemText, Link, Button } from '@mui/material';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import SecurityIcon from '@mui/icons-material/Security';
import CloudDoneIcon from '@mui/icons-material/CloudDone';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import LanguageIcon from '@mui/icons-material/Language';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

export const ManualLapId = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate('/user_manuals')}
        sx={{ mb: 3 }}
      >
        Zurück zum Handbuch
      </Button>
      <Paper elevation={3} sx={{ p: 4, mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <VerifiedUserIcon color="primary" sx={{ fontSize: 40 }} />
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
            LapID App – Führerscheinkontrolle
          </Typography>
        </Box>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Die LapID App ermöglicht eine einfache und sichere Führerscheinkontrolle per Smartphone. 
          Sie ist speziell für Unternehmen entwickelt, um die gesetzlich vorgeschriebene Kontrolle der Führerscheine von Dienstwagenfahrern digital und effizient durchzuführen.
        </Typography>
        <List sx={{ mb: 2 }}>
          <ListItem>
            <ListItemIcon>
              <SmartphoneIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Mobile Kontrolle"
              secondary="Führerscheinkontrolle jederzeit und überall per Smartphone – flexibel und ortsunabhängig."
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <SecurityIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Rechtssicherheit"
              secondary="Die App erfüllt alle gesetzlichen Anforderungen und dokumentiert die Kontrolle revisionssicher."
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CloudDoneIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Digitale Dokumentation"
              secondary="Alle Kontrollen werden automatisch digital erfasst und können jederzeit eingesehen werden."
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <HelpOutlineIcon color="primary" />
            </ListItemIcon>
            <ListItemText
              primary="Schritt-für-Schritt-Anleitung"
              secondary="Die App führt den Fahrer intuitiv durch den gesamten Kontrollprozess."
            />
          </ListItem>
        </List>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Die LapID App ist sowohl für iOS als auch für Android verfügbar. Nach der Installation melden Sie sich mit Ihren Zugangsdaten an und folgen den Anweisungen zur Führerscheinkontrolle.
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Bei Fragen oder Problemen wenden Sie sich bitte an Ihre Fuhrparkleitung oder nutzen Sie die Hilfefunktion innerhalb der App.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Weitere Informationen und Anleitungen zur Nutzung der LapID App erhalten Sie auf der offiziellen LapID Webseite.
        </Typography>
        <Box sx={{ mt: 3, display: 'flex', alignItems: 'center', gap: 1 }}>
          <LanguageIcon color="primary" />
          <Link href="https://www.lapid.de/fuehrerscheinkontrolle/driver-app/" target="_blank" rel="noopener">
            Offizielle LapID Driver App Webseite
          </Link>
        </Box>
      </Paper>
      <Box sx={{ mt: 2, mb: 4 }}>
        <Paper elevation={1} sx={{ p: 2, backgroundColor: '#f5f5f5' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
            Quellen / Sources:
          </Typography>
          <ul style={{ margin: 0, paddingLeft: '1.2em' }}>
            <li>
              <Link href="https://www.lapid.de/fuehrerscheinkontrolle/driver-app/" target="_blank" rel="noopener">
                https://www.lapid.de/fuehrerscheinkontrolle/driver-app/
              </Link>
            </li>
            <li>
              LapID Informationsmaterial und eigene Erfahrungen
            </li>
          </ul>
        </Paper>
      </Box>
    </Container>
  );
};

export default ManualLapId;